(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["corelewear-filter-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('corelewear-filter-grid')) {
    class CorelewearFilterGrid extends HTMLElement {
      connectedCallback() {
        this.items = [...this.querySelectorAll('.clw-filter__item')];
        this.chips = [...this.querySelectorAll('.clw-chip')];
        this.status = this.querySelector('[data-status]');
        this.empty = this.querySelector('[data-empty]');
        this.state = { color: '', fabric: '' };

        this.items.forEach((item) => {
          try {
            item.images = JSON.parse(item.dataset.images || '{}');
          } catch (e) {
            item.images = {};
          }
          const img = item.querySelector('.clw-card__media img:not(.clw-card__img--hover)');
          if (img) item.original = { img, src: img.src, srcset: img.srcset };
        });

        const params = new URLSearchParams(window.location.search);
        ['color', 'fabric'].forEach((group) => {
          const key = params.get(group) || '';
          if (this.chips.some((c) => c.dataset.group === group && c.dataset.key === key)) this.state[group] = key;
        });

        this.addEventListener('click', (event) => {
          const chip = event.target.closest('.clw-chip');
          if (chip && !chip.disabled) {
            const { group, key } = chip.dataset;
            this.state[group] = this.state[group] === key ? '' : key;
            this.update(true);
          }
          if (event.target.closest('[data-reset]')) {
            this.state = { color: '', fabric: '' };
            this.update(true);
          }
        });

        this.update(false);

        this.rows = [...this.querySelectorAll('.clw-filter__chips')];
        this.checkOverflow = () =>
          this.rows.forEach((row) => row.classList.toggle('is-overflowing', row.scrollWidth > row.clientWidth + 1));
        this.checkOverflow();
        this.resizeObserver = new ResizeObserver(this.checkOverflow);
        this.rows.forEach((row) => this.resizeObserver.observe(row));
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      matches(item, color, fabric) {
        return (!color || item.dataset.colors.includes(`|${color}|`)) && (!fabric || item.dataset.fabrics.includes(`|${fabric}|`));
      }

      update(pushUrl) {
        const { color, fabric } = this.state;
        let shown = 0;

        this.items.forEach((item) => {
          const visible = this.matches(item, color, fabric);
          item.hidden = !visible;
          if (visible) shown += 1;

          // Show the photo of the chosen colour; restore the default otherwise.
          if (item.original) {
            const { img, src, srcset } = item.original;
            const swap = color && item.images[color];
            img.src = swap || src;
            if (swap) img.removeAttribute('srcset');
            else if (srcset) img.srcset = srcset;
          }
        });

        this.chips.forEach((chip) => {
          const { group, key } = chip.dataset;
          const active = this.state[group] === key;
          chip.classList.toggle('is-active', active);
          chip.setAttribute('aria-pressed', String(active));

          if (key) {
            // Count what this chip would show alongside the other group's choice.
            const other = group === 'color' ? { color: key, fabric } : { color, fabric: key };
            const count = this.items.filter((item) => this.matches(item, other.color, other.fabric)).length;
            const counter = chip.querySelector('[data-count]');
            if (counter) counter.textContent = count;
            chip.disabled = count === 0 && !active;
          }
        });

        this.empty.hidden = shown > 0;
        this.status.textContent = `${shown} ${shown === 1 ? 'style' : 'styles'}`;

        if (pushUrl) {
          const url = new URL(window.location.href);
          ['color', 'fabric'].forEach((group) => {
            if (this.state[group]) url.searchParams.set(group, this.state[group]);
            else url.searchParams.delete(group);
          });
          window.history.replaceState({}, '', url);
        }
      }
    }

    customElements.define('corelewear-filter-grid', CorelewearFilterGrid);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corelewear-product-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clw-reviews-list')) {
    class ClwReviewsList extends HTMLElement {
      connectedCallback() {
        this.step = Math.max(Number(this.dataset.step) || 8, 1);
        this.more = this.querySelector('[data-more]');
        this.lightbox = this.querySelector('[data-lightbox]');
        this.lightboxImg = this.querySelector('[data-lightbox-img]');

        this.more?.addEventListener('click', () => this.showMore());
        this.addEventListener('click', (event) => {
          const photo = event.target.closest('.clw-rv__photo');
          if (photo) return this.openPhoto(photo.dataset.full);
          if (event.target.closest('[data-close]') || event.target === this.lightbox) this.lightbox?.close();
        });
        this.lightbox?.addEventListener('close', () => {
          if (this.lightboxImg) this.lightboxImg.src = '';
        });
        this.updateMore();
      }

      hiddenItems() {
        return Array.from(this.querySelectorAll('.clw-rv__item[hidden]'));
      }

      showMore() {
        this.hiddenItems().slice(0, this.step).forEach((item) => item.removeAttribute('hidden'));
        this.updateMore();
      }

      updateMore() {
        if (this.more && !this.hiddenItems().length) this.more.parentElement.hidden = true;
      }

      openPhoto(src) {
        if (!src || !this.lightbox || !this.lightboxImg) return;
        this.lightboxImg.src = src;
        if (typeof this.lightbox.showModal === 'function') this.lightbox.showModal();
        else this.lightbox.setAttribute('open', '');
      }
    }
    customElements.define('clw-reviews-list', ClwReviewsList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["corelewear-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clw-welcome-popup')) {
    const KEY_HIDE = 'clw_welcome_hidden_until';
    const KEY_DONE = 'clw_welcome_done';
    const read = (key) => {
      try {
        return localStorage.getItem(key);
      } catch (e) {
        return null;
      }
    };
    const write = (key, value) => {
      try {
        localStorage.setItem(key, value);
      } catch (e) {}
    };

    class ClwWelcomePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.querySelectorAll('[data-welcome-close]').forEach((el) =>
          el.addEventListener('click', () => this.close())
        );
        this.dialog.addEventListener('cancel', () => this.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.querySelector('[data-welcome-copy]')?.addEventListener('click', () => this.copyCode());
        this.querySelector('form')?.addEventListener('submit', () => this.beforeSubmit());
        // Passive "Get 10% off" tab: always available until the customer signs up.
        this.teaser = this.querySelector('[data-welcome-teaser]');
        this.teaser?.addEventListener('click', () => this.open(true));
        this.toggleTeaser(!read(KEY_DONE) && !this.querySelector('[data-welcome-success]'));

        // After a submit the page reloads: show the result (code or error) right away.
        if (this.querySelector('[data-welcome-success]')) {
          write(KEY_DONE, '1');
          this.open();
          return;
        }
        if (this.querySelector('[data-welcome-error]')) {
          this.open();
          return;
        }

        if (this.dataset.designMode === 'true') {
          this.open();
          return;
        }
        if (read(KEY_DONE)) return;
        if (Number(read(KEY_HIDE) || 0) > Date.now()) return;
        const delay = Math.max(0, Number(this.dataset.delay || 5)) * 1000;
        this.timer = setTimeout(() => this.open(), delay);
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
      }

      toggleTeaser(show) {
        if (this.teaser) this.teaser.hidden = !show;
      }

      open(fromTeaser = false) {
        if (this.dialog.open || (!fromTeaser && document.querySelector('dialog[open]'))) return;
        clearTimeout(this.timer);
        this.toggleTeaser(false);
        this.dialog.showModal();
        window.clwClarity?.click({ event: 'welcome_popup_view' });
      }

      close() {
        if (!this.querySelector('[data-welcome-success]')) {
          const days = Number(this.dataset.days || 7);
          write(KEY_HIDE, String(Date.now() + days * 864e5));
        }
        this.dialog.close();
        this.toggleTeaser(!read(KEY_DONE));
      }

      beforeSubmit() {
        const tags = this.querySelector('[data-welcome-tags]');
        const phone = this.querySelector('input[type="tel"]');
        if (!tags) return;
        const list = ['newsletter', 'popup-10'];
        const digits = (phone?.value || '').replace(/\D/g, '');
        if (digits) list.push(`tel-${digits}`);
        if (this.querySelector('[data-welcome-sms]')?.checked) list.push('sms-consent');
        tags.value = list.join(',');
      }

      copyCode() {
        const code = this.querySelector('[data-welcome-code]')?.textContent.trim();
        const button = this.querySelector('[data-welcome-copy]');
        if (!code || !button) return;
        navigator.clipboard?.writeText(code).then(() => {
          button.textContent = 'Copied';
        });
      }
    }
    customElements.define('clw-welcome-popup', ClwWelcomePopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
